import ObjectAvatar from "@molecules/ObjectAvatar/ObjectAvatar"
import SelectListItem from "@molecules/Select/SelectListItem/SelectListItem"

import { ObjectSelectListItemProps } from "./ObjectSelectListItem.types"

export default function ObjectSelectListItem<T extends string = string>(props: ObjectSelectListItemProps<T>) {
    const { objectType, item, hasSupportText, supportText, hasSubtext, subtext, ...rest } = props

    const baseProps = {
        variant: "default" as const,
        layout: "object" as const,
        item: {
            ...item,
            leading: <ObjectAvatar objectType={objectType} size="xl" />,
        },
        ...rest,
    }

    if (hasSupportText && supportText) {
        return <SelectListItem {...baseProps} hasSupportText={true} supportText={supportText} />
    }

    if (hasSubtext && subtext) {
        return <SelectListItem {...baseProps} hasSubtext={true} subtext={subtext} />
    }

    return <SelectListItem {...baseProps} />
}
